// Utils
import platformSingleton from '../../../platform/platformSingleton';
import { holdFocus } from './touchScreenFocusUtils';
import { isPlatformIos } from '../../../platform/utils/platformDetailsUtils';

// Constants
import { ELEMENT_EDIT_START } from '../../../../common/elements/selectionConstants';

// Types
import { UnknownAction } from 'redux';
import { ReduxStore } from '../../../types/reduxTypes';

export default (store: ReduxStore) => (next: Function) => async (action: UnknownAction) => {
    if (action.remote) return next(action);

    // The logic below focuses the fake input on iOS to ensure that the virtual keyboard is shown - as iOS requires
    // a synchronous input focus in order to bring up the virtual keyboard initially. The focused input can
    // then be changed to the actual element asynchronously afterwards.
    //
    // We don't want to do it on Android otherwise the keyboard might flash up then disappear then show again
    if (action.type === ELEMENT_EDIT_START && isPlatformIos(platformSingleton)) {
        const inputType = (action.inputType as string) || 'text';

        holdFocus({ inputType, readOnly: !!action.preventVirtualKeyboard });
    }

    next(action);
};
